import React, { useState } from 'react';
import { Link } from 'react-scroll';
  
  const NewsMenu = ({
    pathname,
    location_origin,
    newsMenuOpen,
    setNewsMenuOpen,
    togglerClose,
    setTogglerClose,
    colorMenu,
    colorMenuTOG,
    closeAll,
  }) => {

    const toggleNewsMenu = () => {
      closeAll();
      setNewsMenuOpen(!newsMenuOpen);
  };

  const links = [
    { label: 'Articoli', href: `${location_origin}news#newsLink` },
    { label: 'Video', href: `${location_origin}news#videoLink` },
    { label: 'Infografiche', href: `${location_origin}infografica` }
  ];

  const renderLink = ({ label, href }) => {
    const link = href;
    const isCurrentPath = pathname === '/news';
    const onClickHandler = () => setTogglerClose(true);


    return (
      <li className="nav-item downMenu">
        {isCurrentPath ? (
          <Link to={href} spy smooth onClick={onClickHandler}>
            {label}
          </Link>
        ) : (
          <a href={link}>{label}</a>
        )}
      </li>
    );
  };
        
  
    return (
      <li className={togglerClose ? "nav-item" : "navItemToggler"} >
        <div className={`nav-link ${pathname === '/news' ? 'active' : ''}`}>
            <a
            style={{ color: !togglerClose ? colorMenuTOG : colorMenu }}
            title="notaio treviso news"
            href={`${location_origin}news`}
            >
            News
            </a>
            <i
            onClick={toggleNewsMenu}
            className={`fa fa-caret-${newsMenuOpen ? 'up' : 'down'} tagMenu`}
            aria-hidden="true"
            />
        </div>
        {newsMenuOpen && (
            <div className={togglerClose ? "menuDown" : "menuDownToggler"}>
                {links.map((link) => renderLink(link))}
            </div>
        )}
    </li>
    );
};
  
  export default NewsMenu;
  